"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = require("uuid");
var Channel = /** @class */ (function () {
    function Channel(axiosClient, connection, userInfo, channelType, channelId, data, messages, lastMessageRead, members) {
        var _a;
        this.delayBetweenRetries = 1000;
        this.listeners = {};
        this.isWatched = false;
        this.unreadMessagesCount = 0;
        this.delay = function (delayInMs) {
            return new Promise(function (resolve) { return setTimeout(resolve, delayInMs); });
        };
        this.chunkSize = 100;
        this.axiosClient = axiosClient;
        this.connection = connection;
        this.channelType = channelType;
        this.channelId = channelId;
        this.userInfo = userInfo;
        this.data = data;
        this.messages = messages || [];
        this.lastMessage = (_a = this.messages) === null || _a === void 0 ? void 0 : _a[this.messages.length - 1];
        this.lastMessageRead = lastMessageRead;
        this.unreadMessagesCount = this.getUnreadMessagesCount();
        this.selectedReplyMessage = null;
        this.moderators = [];
        this.members = members || [];
    }
    Object.defineProperty(Channel.prototype, "id", {
        get: function () {
            return "" + this.channelId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Channel.prototype, "name", {
        get: function () {
            var _a;
            return (_a = this.data.name) !== null && _a !== void 0 ? _a : "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Channel.prototype, "currentUserId", {
        get: function () {
            return this.userInfo.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Channel.prototype, "isBeingWatched", {
        get: function () {
            return this.isWatched;
        },
        enumerable: false,
        configurable: true
    });
    Channel.prototype.create = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axiosClient.post("/api/channels", {
                            id: this.channelId,
                            name: this.data.name,
                            type: this.channelType,
                            members: this.data.members,
                        })];
                    case 1:
                        response = _a.sent();
                        if (this.channelType === "private") {
                            this.channelId = response.data.id;
                        }
                        if (!(this.data.members && this.channelType === "public")) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.addMembers(this.data.members)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.updateMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!message.serverId.length) {
                            throw new Error("serverId field is required");
                        }
                        return [4 /*yield*/, this.axiosClient.put("/api/messages/" + message.serverId, message)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.removeMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!message.serverId.length) {
                            throw new Error("serverId field is required");
                        }
                        return [4 /*yield*/, this.axiosClient.delete("/api/messages/" + message.serverId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.sendMessage = function (text, fileToken, maxSendMessageRetries) {
        var _a, _b, _c;
        if (fileToken === void 0) { fileToken = ""; }
        if (maxSendMessageRetries === void 0) { maxSendMessageRetries = 15; }
        return __awaiter(this, void 0, void 0, function () {
            var serverMessage, message, ex_1;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        serverMessage = {
                            clientId: this.userInfo.id + "-" + uuid_1.v4(),
                            channelId: this.channelId,
                            senderId: this.userInfo.id.toString(),
                            text: text,
                            fileToken: fileToken,
                            date: new Date().toISOString(),
                        };
                        message = __assign(__assign({}, serverMessage), { serverId: "", sender: {
                                id: this.userInfo.id.toString(),
                                name: this.userInfo.name,
                                image: (_a = this.userInfo.image) !== null && _a !== void 0 ? _a : "",
                            }, replyId: (_c = (_b = this.selectedReplyMessage) === null || _b === void 0 ? void 0 : _b.serverId) !== null && _c !== void 0 ? _c : "" });
                        this.dispatchEvent({ type: "sendingMessage", message: message });
                        this.setReplyMessage(null);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.retryPolicy(function () { return _this.axiosClient.post("/api/messages", message); }, function (ex, runs) { return !ex.code && runs <= maxSendMessageRetries; })];
                    case 2:
                        _d.sent();
                        this.dispatchEvent({ type: "messageSent", message: message });
                        return [3 /*break*/, 4];
                    case 3:
                        ex_1 = _d.sent();
                        this.dispatchEvent({ type: "messageFailed", message: message });
                        throw ex_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.queryMessages = function (limit, lowerThanId, greaterThanId) {
        return __awaiter(this, void 0, void 0, function () {
            var parameters, response, messages;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parameters = "limit=" + (limit !== null && limit !== void 0 ? limit : 100);
                        if (lowerThanId)
                            parameters += "&lowerThanId=" + lowerThanId;
                        if (greaterThanId)
                            parameters += "&greaterThanId=" + greaterThanId;
                        return [4 /*yield*/, this.axiosClient.get("/api/channels/" + this.channelId + "/messages?" + parameters)];
                    case 1:
                        response = _a.sent();
                        messages = response.data;
                        return [2 /*return*/, messages];
                }
            });
        });
    };
    Channel.prototype.queryLastMessageRead = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, lastMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axiosClient.get("/api/channels/" + this.channelId + "/messages/read")];
                    case 1:
                        response = _a.sent();
                        lastMessage = response.data;
                        return [2 /*return*/, lastMessage];
                }
            });
        });
    };
    Channel.prototype.markMessageAsRead = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var currentDate, desiredDate, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.lastMessageRead) {
                            currentDate = Date.parse(this.lastMessageRead.date);
                            desiredDate = Date.parse(message.date);
                            if (desiredDate - currentDate <= 0)
                                return [2 /*return*/, this.lastMessageRead];
                        }
                        this.lastMessageRead = message;
                        return [4 /*yield*/, this.axiosClient.post("/api/channels/" + this.channelId + "/messages/read", message)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    Channel.prototype.setReplyMessage = function (message) {
        this.selectedReplyMessage = message;
        this.dispatchEvent({
            type: "replyMessage",
            message: message,
            channelId: this.channelId,
        });
    };
    Channel.prototype.markLastMessageAsRead = function () {
        return __awaiter(this, void 0, void 0, function () {
            var message, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.messages.length)
                            return [2 /*return*/, Promise.resolve(undefined)];
                        message = this.messages[this.messages.length - 1];
                        return [4 /*yield*/, this.markMessageAsRead(message)];
                    case 1:
                        result = _a.sent();
                        this.unreadMessagesCount = 0;
                        this.dispatchEvent({
                            type: "updateUnreadCount",
                            count: this.unreadMessagesCount,
                        });
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Channel.prototype.getUnreadMessagesCount = function () {
        var lastMessageRead = this.lastMessageRead;
        if (!lastMessageRead) {
            return this.messages.length;
        }
        var lastReadDate = new Date(lastMessageRead.date);
        return this.messages.reduce(function (acc, message) {
            var currentDate = new Date(message.date);
            if (lastReadDate < currentDate) {
                return acc + 1;
            }
            return acc;
        }, 0);
    };
    Channel.prototype.watch = function (createItFirst) {
        var _a;
        if (createItFirst === void 0) { createItFirst = true; }
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!createItFirst) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.create()];
                    case 1:
                        _e.sent();
                        _b = this;
                        return [4 /*yield*/, this.queryMessages(this.chunkSize)];
                    case 2:
                        _b.messages = _e.sent();
                        _c = this;
                        return [4 /*yield*/, this.queryLastMessageRead()];
                    case 3:
                        _c.lastMessageRead = _e.sent();
                        this.messages.sort(function (a, b) { return a.date.localeCompare(b.date); });
                        this.lastMessage = (_a = this.messages) === null || _a === void 0 ? void 0 : _a[this.messages.length - 1];
                        this.unreadMessagesCount = this.getUnreadMessagesCount();
                        _e.label = 4;
                    case 4:
                        this.connection.publish({
                            type: "subscribe",
                            channelsIds: [this.channelId],
                        });
                        this.isWatched = true;
                        if (!(this.channelType !== "public")) return [3 /*break*/, 6];
                        _d = this.data;
                        return [4 /*yield*/, this.queryMembers()];
                    case 5:
                        _d.members = _e.sent();
                        _e.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.stopWatching = function () {
        this.connection.publish({
            type: "unsubscribe",
            channelsIds: [this.channelId],
        });
        this.isWatched = false;
    };
    Channel.prototype.addMembers = function (members) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.axiosClient.patch("/api/channels/" + this.channelId + "/members", members)];
                    case 1:
                        _b.sent();
                        this.data.members = Array.from(new Set(__spreadArray(__spreadArray([], ((_a = this.data.members) !== null && _a !== void 0 ? _a : [])), members)));
                        this.dispatchEvent({
                            type: "addMembers",
                            members: members,
                            channelId: this.channelId,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.removeMembers = function (members) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.axiosClient.delete("/api/channels/" + this.channelId + "/members", {
                            data: members,
                        })];
                    case 1:
                        _b.sent();
                        this.data.members = ((_a = this.data.members) !== null && _a !== void 0 ? _a : []).filter(function (member) { return !members.includes(member); });
                        this.dispatchEvent({
                            type: "removeMembers",
                            members: members,
                            channelId: this.channelId,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.addModerators = function (moderators) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axiosClient.patch("/api/channels/" + this.channelId + "/moderators", moderators)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.demoteModerators = function (moderators) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axiosClient.delete("/api/channels/" + this.channelId + "/moderators", {
                            data: moderators,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.addReaction = function (emoji, message) {
        return __awaiter(this, void 0, void 0, function () {
            var reaction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reaction = {
                            emoji: emoji,
                            messageId: message.serverId,
                            userId: this.currentUserId,
                            serverId: "",
                        };
                        return [4 /*yield*/, this.axiosClient.post("/api/reactions", {
                                reaction: reaction,
                                channelId: this.channelId,
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.deleteReaction = function (reaction) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!reaction.serverId.length) {
                            throw new Error("serverId field is required");
                        }
                        return [4 /*yield*/, this.axiosClient.delete("/api/reactions/" + reaction.serverId, {
                                data: { channelId: this.channelId },
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.queryMembers = function (limit, lowerThanId, greaterThanId) {
        return __awaiter(this, void 0, void 0, function () {
            var parameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parameters = Channel.query(limit, lowerThanId, greaterThanId);
                        return [4 /*yield*/, this.axiosClient.get("/api/channels/" + this.channelId + "/members?" + parameters)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    Channel.prototype.queryModerators = function (limit, lowerThan, greaterThan) {
        return __awaiter(this, void 0, void 0, function () {
            var parameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.channelType === "private")
                            return [2 /*return*/, this.moderators];
                        parameters = Channel.query(limit, lowerThan, greaterThan);
                        return [4 /*yield*/, this.axiosClient.get("/api/channels/" + this.channelId + "/moderators?" + parameters)];
                    case 1:
                        response = _a.sent();
                        this.moderators = response.data;
                        return [2 /*return*/, this.moderators];
                }
            });
        });
    };
    Channel.prototype.on = function (eventType, handler) {
        var _this = this;
        if (this.listeners[eventType]) {
            this.listeners[eventType].push(handler);
        }
        else {
            this.listeners[eventType] = [handler];
        }
        return {
            unsubscribe: function () {
                _this.listeners[eventType] = _this.listeners[eventType].filter(function (listener) { return listener !== handler; });
            },
        };
    };
    Channel.prototype.off = function (eventType, handler) {
        if (this.listeners[eventType]) {
            this.listeners[eventType] = this.listeners[eventType].filter(function (listener) { return listener !== handler; });
        }
    };
    Channel.prototype.dispatchEvent = function (evt) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.handleMessage(evt)];
                    case 1:
                        _a.sent();
                        this.notifyListeners(evt);
                        return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.handleMessage = function (evt) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedMessageIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(evt.type === "connected" && this.isWatched)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.watch()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        if (evt.type === "newMessage") {
                            this.messages = this.messages.concat(evt.message);
                            this.lastMessage = evt.message;
                            this.unreadMessagesCount += 1;
                            if (evt.message.senderId === this.userInfo.id) {
                                this.markMessageAsRead(evt.message);
                                this.unreadMessagesCount = 0;
                            }
                            this.dispatchEvent({
                                type: "updateUnreadCount",
                                count: this.unreadMessagesCount,
                            });
                        }
                        else if (evt.type === "messageUpdated") {
                            updatedMessageIndex = this.messages.findIndex(function (m) { return m.serverId === evt.message.serverId; });
                            this.messages[updatedMessageIndex] = __assign(__assign({}, evt.message), { sender: this.messages[updatedMessageIndex].sender });
                        }
                        else if (evt.type === "messageRemoved") {
                            this.messages = this.messages.filter(function (m) { return m.serverId !== evt.message.serverId; });
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.notifyListeners = function (evt) {
        var listeners = [];
        if (this.listeners.all) {
            listeners.push.apply(listeners, this.listeners.all);
        }
        if (this.listeners[evt.type]) {
            listeners.push.apply(listeners, this.listeners[evt.type]);
        }
        listeners.forEach(function (listener) { return listener(evt); });
    };
    Channel.prototype.retryPolicy = function (action, shouldRetry, runs) {
        if (runs === void 0) { runs = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var ex_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 5]);
                        return [4 /*yield*/, action()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 2:
                        ex_2 = _a.sent();
                        if (!shouldRetry(ex_2, runs + 1)) {
                            throw ex_2;
                        }
                        return [4 /*yield*/, this.delay(this.delayBetweenRetries)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.retryPolicy(action, shouldRetry, runs + 1)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Channel.query = function (limit, lowerThan, greaterThan) {
        var parameters = "limit=" + (limit !== null && limit !== void 0 ? limit : 100);
        if (lowerThan)
            parameters += "&lowerThan=" + lowerThan;
        if (greaterThan)
            parameters += "&greaterThan=" + greaterThan;
        return parameters;
    };
    return Channel;
}());
exports.default = Channel;
//# sourceMappingURL=channel.js.map